import {
  BaseTable,
  SortConfig,
  type Column,
} from '@/components/table/BaseTable'
import { DestinationsList } from '@/types/destinationsList'
import { css, Theme } from '@emotion/react'
import { Link } from 'react-router-dom'

const dateFormatter = new Intl.DateTimeFormat('ja-JP', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

const tableWrapperStyles = css`
  overflow-x: auto;
`
const LinkStyle = (t: Theme) => css`
  cursor: pointer;
  text-decoration: none;
  color: ${t.c.bc.primary};

  &:hover {
    text-decoration: underline;
  }
`

const startDateWidth = 160
const destinationCodeWidth = 120
const nameWidth = 440
const addressWidth = 640
const columns: Column<DestinationsList>[] = [
  {
    header: '適用開始日',
    text: (row) => {
      return dateFormatter.format(new Date(row.startDate))
    },
    width: `${startDateWidth}px`,
    divStyle: {
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    sortKey: 'start_date',
  },
  {
    header: '送達先番号',
    accessor: (row) => {
      return (
        <Link css={LinkStyle} to={`${row.id}/view`}>
          {row.destinationCode}
        </Link>
      )
    },
    text: (row) => row.destinationCode,
    width: `${destinationCodeWidth}px`,
    isDetailLink: true,
    sortKey: 'destination_code',
  },
  {
    header: '送達先名',
    text: (row) => row.name,
    width: `${nameWidth}px`,
  },
  {
    header: '住所',
    text: (row) =>
      row.addressLine1 + (row.addressLine2 ? `\n${row.addressLine2}` : ''),
    width: `${addressWidth}px`,
    isEllipsis: true,
  },
]

type Props = {
  data: DestinationsList[]
  sortConfig?: SortConfig
  onSort?: (key: string) => void
}

export const DestinationTable = ({ data, sortConfig, onSort }: Props) => {
  return (
    <div css={tableWrapperStyles}>
      <BaseTable
        data={data}
        columns={columns}
        isDelete={false}
        needIcon={true}
        sortConfig={sortConfig}
        onSort={onSort}
        width={`${startDateWidth + destinationCodeWidth + nameWidth + addressWidth}px`}
      />
    </div>
  )
}
